import outsideDirective from '../directives/outside'

import type { App } from 'vue'
import type { ActionPool } from '../directives/outside'

export function outside() {
  return {
    install(app: App) {
      const actionPool: ActionPool = []
      app.directive('outside', outsideDirective(actionPool))
    },
  }
}
